import { FiCheck, FiZap } from "react-icons/fi";

interface WorkoutPlanAIModalFooterProps {
  readonly hasResult: boolean;
  readonly aiLoading: boolean;
  readonly description: string;
  readonly visiblePrescriptionsCount: number;
  readonly onClose: () => void;
  readonly onAnalyze: () => void;
  readonly onBack: () => void;
  readonly onApply: () => void;
}

export function WorkoutPlanAIModalFooter({
  hasResult,
  aiLoading,
  description,
  visiblePrescriptionsCount,
  onClose,
  onAnalyze,
  onBack,
  onApply,
}: WorkoutPlanAIModalFooterProps) {
  if (!hasResult) {
    return (
      <div className="border-t border-stroke bg-white px-4 sm:px-8 py-4 sm:py-6 dark:border-strokedark dark:bg-boxdark">
        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
          <button
            type="button"
            onClick={onClose}
            className="w-full sm:w-auto rounded-xl border border-stroke px-4 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base font-semibold text-gray-700 transition-all hover:bg-gray-50 hover:shadow-sm dark:border-strokedark dark:text-gray-300 dark:hover:bg-gray-800/50"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onAnalyze}
            disabled={aiLoading || !description.trim()}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-purple-600 to-purple-700 px-6 sm:px-8 py-2.5 sm:py-3 text-sm sm:text-base font-semibold text-white shadow-sm transition-all hover:scale-105 hover:shadow-xl disabled:opacity-50 disabled:hover:scale-100"
          >
            {aiLoading ? (
              <>
                <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                Criando Treino...
              </>
            ) : (
              <>
                <FiZap size={18} />
                Criar Treino
              </>
            )}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="border-t border-stroke bg-white px-4 sm:px-8 py-4 sm:py-6 dark:border-strokedark dark:bg-boxdark">
      <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
        <button
          type="button"
          onClick={onBack}
          className="w-full sm:w-auto rounded-xl border border-stroke px-4 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base font-semibold text-gray-700 transition-all hover:bg-gray-50 hover:shadow-sm dark:border-strokedark dark:text-gray-300 dark:hover:bg-gray-800/50"
        >
          Voltar
        </button>
        <button
          type="button"
          onClick={onApply}
          disabled={visiblePrescriptionsCount === 0}
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-green-600 to-green-700 px-6 sm:px-8 py-2.5 sm:py-3 text-sm sm:text-base font-semibold text-white shadow-sm transition-all hover:scale-105 hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
        >
          <FiCheck size={18} />
          Aplicar Treinos{" "}
          {visiblePrescriptionsCount > 0 && `(${visiblePrescriptionsCount})`}
        </button>
      </div>
    </div>
  );
}
